import { BrowserRouter } from 'react-router-dom';
import AppProvider from './hooks';
import RootRoutes from './routes';
import './App.css';
import GlobalStyle from './styles/global';

const App: React.FC = () => (
  <>
    <AppProvider>
      <BrowserRouter>
        <RootRoutes />
      </BrowserRouter>
    </AppProvider>
    <GlobalStyle />
  </>
);

export default App;
